export default {
  data() {
    return {
      showMySelectionHelpers: false,
    }
  },
  computed: {
    favoritesLength() {
      let favorites = [];

      if (this.album && this.favorites && this.favorites.length > 0) {
        this.favorites.forEach((album) => {
          if (album.albumId === this.album.id) {
            album.items.forEach((photo) => {
              favorites.push(photo);
            });
          }
        });
      }

      return favorites.length;
    },
    helperMySelectionStep1() {
      return this.$store.getters.HELPER_MY_SELECTION_STEP_1;
    },
    helperMySelectionStep2() {
      return this.$store.getters.HELPER_MY_SELECTION_STEP_2;
    },
  },
  watch: {
    '$route'(route) {
      this.handleAlbumRoutes(route.name);
      if (route.name) {
        document.body.setAttribute('page', route.name);
      } else {
        document.body.removeAttribute('page');
      }
    },
    prevRoute: async function(prevRoute) {
      if (prevRoute && prevRoute.name === 'login') {
        const remoteProducts = await this.$store.dispatch('INIT_CART');
        remoteProducts && remoteProducts.length > 0 &&
        this.showMergeCartModal(remoteProducts);
      }
    },
    helperMySelectionStep1() {
      this.showMySelectionHelpers = false;
    },
    helperMySelectionStep2() {
      this.showMySelectionHelpers = false;
    },
    favoritesLength() {
      if (this.favorites && this.favorites.length === 1 && this.products && this.products.length > 0 && !this.helperMySelectionStep1 && this.$route.name !== 'photo') {
        this.showMySelectionHelpers = true;
      }

      if (this.favorites && this.favorites.length === 2 && this.products && this.products.length > 0 && !this.helperMySelectionStep2 && this.$route.name !== 'photo') {
        this.showMySelectionHelpers = true;
      }
    }
  },
  methods: {
    handleAlbumRoutes(routeName) {
      switch (routeName) {
        case 'album':
        case 'tag':
        case 'cart':
        case 'favorites':
          /*if (!this.set) {
            this.closeOrder(true);
          }*/
          break;
        case 'photo':
          if (this.album) {
            this.$store.dispatch('SET_ORDER_STEP', 1);
            this.$store.dispatch('SET_PHOTO',
                this._.find(this.albumPhotos,
                    {id: this.$route.params.photo}));
          }
          break;
        case 'order':
          if (this.uuid) {
            this.$store.dispatch('SET_ORDER_STEP', 4);
          } else if (this.photo) {
            this.$store.dispatch('SET_ORDER_STEP', 2);
          } else {
            this.$router.push(
                this.i18nLink(`album/gallery/${this.$route.params.hash}`));
          }
          break;
      }
    },
  },
  async created() {
    this.$store.dispatch('INIT_USER');
    this.$store.dispatch('INIT_CHECKOUT');
    this.$store.dispatch('INIT_FAVORITES');
    this.$store.dispatch('INIT_PRICELISTS');
    this.$store.dispatch('INIT_CUSTOMER_ITEMS');
    this.$store.dispatch('INIT_COUNTRY_OPTIONS');
    this.$store.dispatch('INIT_HELPERS_MY_SELECTION');

    this.axios.interceptors.response.use(
        response => response,
        (e) => {
          if (e.response && e.response.status === 401) {
            this.logout();
          }
        },
    );

    if (this.$route.name === 'order') {
      this.$router.push(
          this.i18nLink(`album/gallery/${this.$route.params.hash}`));
    }

    const remoteProducts = await this.$store.dispatch('INIT_CART');
    remoteProducts && remoteProducts.length > 0 &&
    this.showMergeCartModal(remoteProducts);
  },
  mounted() {
    if (!localStorage.getItem('cookies') && this.$route.name !== '404') {
      this.showCookieInformationModal();
    }

    if (this.coreParams.theme_settings.sidebar) {
      document.body.classList.add('-sidebar');
    }
  },
};
